const resolveWorkspaceUser = (userOrEmail) => {
  if (!userOrEmail) {
    return null;
  }

  if (typeof userOrEmail === 'string') {
    return userOrEmail.trim() ? { email: userOrEmail.trim() } : null;
  }

  return userOrEmail;
};

export const hasWorkspaceAccess = (userOrEmail) => {
  const user = resolveWorkspaceUser(userOrEmail);
  return Boolean(user?.uid || user?.email);
};

export const getWorkspaceAllowlist = () => [];

export const canAccessWorkspaces = (userOrEmail, isBackendEnabled = true) => {
  return Boolean(isBackendEnabled) && hasWorkspaceAccess(userOrEmail);
};

export const canUseWorkspaceBackend = (userOrEmail, isBackendEnabled = true) => {
  return Boolean(isBackendEnabled) && hasWorkspaceAccess(userOrEmail);
};